import { useNavigate } from "react-router";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import NewTheMembersForm from "../../../components/apps/themembers/NewTheMembersForm";

export default function NewTheMembers() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps/themembers`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Nova Integração TheMembers"
                description="Criar nova integração TheMembers"
            />
            <PageBreadcrumb
                pageTitle="Nova Integração TheMembers"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewTheMembersForm
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de webhooks
                        navigate(`/apps/themembers`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar integração TheMembers:", error);
                    }}
                />
            </div>
        </>
    );
}